import { network } from 'services/network';
import { useQuery } from 'react-query';
import qs from 'qs';

const getNlpThresholds = (params) => {
    const querystring = qs.stringify({ ProjectId: params.projectId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getClusterType${querystring}`;
    return network.post(url).then((response) => {
        return response.data;
    });
};

export const useQueryGetNlpThresholds = (params) => {
    return useQuery(['getNlpThresholds', params], () => getNlpThresholds(params), {
        enabled: Boolean(params.projectId),
    });
};
